import { createJSONStorage, persist } from 'zustand/middleware';
import { create } from 'zustand';
import { IOrganizationBrandingState } from '@store/organization-branding-store/organization-branding.model.ts';

const useOrganizationBrandingStore = create<IOrganizationBrandingState>()(
  persist(
    (set) => ({
      hasSeenBrandingDialog: false,
      primaryColor: null,
      image: null,
      setHasSeenBrandingDialog: (value) =>
        set({ hasSeenBrandingDialog: value }),
      setPrimaryColor: (color) => set({ primaryColor: color }),
      setImage: (image) => set({ image })
    }),
    {
      name: 'organization-branding-storage',
      storage: createJSONStorage(() => localStorage)
    }
  )
);

export default useOrganizationBrandingStore;
